import React from 'react';
import { connect } from 'react-redux';
import {
  setDesignFixedAnchorageDepthFixedAnchorageHef,
  setDesignFixedAnchorageDepthSpecify,
  setDesignEmbedmentDepthOption
} from '@reducers/selectors/design/actions';
import { APP_TEXTS } from '../../../../texts/texts';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';

import Input from "@components/Input";
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { EmbedmentOptions } from '@reducers/selectors/design';
import { standardList } from '../../../../../src/app.values';

const FixedAnchorageDepth = props => (

  <div className="calculation mt-2">
    {(Number(props.designStandard) === standardList['EU'] || Number(props.designStandard) === standardList['AnnexC']) ? (
      <React.Fragment>
      <section className="list-type">
        <div className="custom-control custom-checkbox d-block">
          <input
            className="custom-control-input"
            id="optimisedDepth"
            name="optimisedDepth"
            onChange={e => {
              props.setFixedAnchorageDepthSpecify(false);
              props.setEmbedmentDepthOption(EmbedmentOptions.standard);
            }}
            checked={!props.specify}
            type="checkbox"
          />
          <label className="custom-control-label" htmlFor="optimisedDepth">
            {APP_TEXTS.OPTIMISED_EMBEDMENT_DEPTH.Content}
          </label>
        </div>
        <div className="custom-control custom-checkbox d-block">
          <input
            className="custom-control-input"
            id="standardDepth"
            name="standardDepth"
            onChange={e => {
              props.setFixedAnchorageDepthSpecify(true);
              props.setEmbedmentDepthOption(EmbedmentOptions.standard);
            }}
            checked={props.specify && props.embedmentOption === EmbedmentOptions.standard}
            type="checkbox"
          />
          <label className="custom-control-label" htmlFor="standardDepth">
            {APP_TEXTS.STANDARD_EMBEDMENT_DEPTH_OPTION.Content}
          </label>
        </div>
        <div className="custom-control custom-checkbox">
          <input
            className="custom-control-input"
            id="specifyAFixedDepth"
            name="specifyAFixedDepth"
            onChange={e => {
              props.setFixedAnchorageDepthSpecify(true);
              props.setEmbedmentDepthOption(EmbedmentOptions.imposed_value);
            }}
            checked={props.specify && props.embedmentOption === EmbedmentOptions.imposed_value}
            type="checkbox"
          />
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_OPTION_SPECIFY_FIXED_DEPTH.Content}>
            <label className="custom-control-label mb-2" htmlFor="specifyAFixedDepth">{APP_TEXTS.FIXED_ANCHORAGE_DEPTH.Content}</label>
          </Tooltip>
        </div>
        {props.embedmentOption === EmbedmentOptions.imposed_value && (
          <div className="d-inline-block">
            <Tooltip content={APP_TOOLTIPS.TOOLTIP_INPUT_DEPTH.Content}>
              <Input
                className="ml-2"
                id="fixedAnchorageHef"
                postfix={<span className="ml-2">{unitLabel(props.unit)}</span>}
                value={unitTransform(props.fixedAnchorageHef || 0).from(defaultUnits.DISTANCE).to(props.unit)}
                disabled={!props.specify}
                onUpdate={value => {
                  props.setFixedAnchorageDepthFixedAnchorageHef(
                    unitTransform(+value, false).from(props.unit).to(defaultUnits.DISTANCE)
                  );
                }}
                type="number"
              />
            </Tooltip>
          </div>
        )}
      </section>

      <section className="list-type">
        <p>
        {APP_TEXTS.FIXED_ANCHORAGE_ADHESIVE_ANCHOR.Content}
        </p>

        <hr />

        <p>
          {APP_TEXTS.FIXED_ANCHORAGE_ADHESIVE_MECHANICAL_ANCHOR.Content}
        </p>
      </section>
      </React.Fragment>
    ) : (Number(props.designStandard) !== standardList['Masonry'] && (
      <React.Fragment>
        <section className="list-type">
          <div className="custom-control custom-checkbox">
            <input
              className="custom-control-input"
              id="specifyAFixedDepth"
              name="specifyAFixedDepth"
              onChange={e => props.setFixedAnchorageDepthSpecify(e.target.checked)}
              checked={props.specify}
              type="checkbox"
            />
            <Tooltip content={APP_TOOLTIPS.TOOLTIP_OPTION_SPECIFY_FIXED_DEPTH.Content}>
            <label className="custom-control-label" htmlFor="specifyAFixedDepth">{APP_TEXTS.FIXED_ANCHORAGE_DEPTH.Content}</label>
            </Tooltip>
          </div>
        </section>

        <section className="list-type">
          <div className="mb-3">
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_INPUT_DEPTH.Content}>
            <Input
              id="fixedAnchorageHef"
              prefix={APP_TEXTS.FIXED_ANCHORAGE_HEF_LABEL.Content}
              postfix={unitLabel(props.unit)}
              value={unitTransform(props.fixedAnchorageHef || 0).from(defaultUnits.DISTANCE).to(props.unit)}
              disabled={!props.specify}
              onUpdate={value => {
                props.setFixedAnchorageDepthFixedAnchorageHef(
                  unitTransform(+value, false).from(props.unit).to(defaultUnits.DISTANCE)
                );
              }}
              type="number"
            />
            </Tooltip>
          </div>

          <p>
          {APP_TEXTS.FIXED_ANCHORAGE_ADHESIVE_ANCHOR.Content}
          </p>

          <hr />

          <p>
            {APP_TEXTS.FIXED_ANCHORAGE_ADHESIVE_MECHANICAL_ANCHOR.Content}
          </p>
        </section>
      </React.Fragment>
    ))}
    
  </div>
);

const mapState = state => ({
  specify: (() => {
    return state.selectors.design[state.main.appType].fixedAnchorageDepth.specify;
  })(),
  fixedAnchorageHef: (() => {
    return state.selectors.design[state.main.appType].fixedAnchorageDepth.fixedAnchorageHef;
  })(),
  embedmentOption: (() => {
    return state.selectors.design[state.main.appType].fixedAnchorageDepth.embedmentOption;
  })(),

  unit: state.main.units.distance,
  appStatus: state.main.status, // use it as a hack to render a potential language change
  designStandard: state.main.localization.designStandard
});

const mapDispatch = dispatch => ({
  setFixedAnchorageDepthSpecify: (value) => {
    dispatch(setDesignFixedAnchorageDepthSpecify(value));
  },
  setFixedAnchorageDepthFixedAnchorageHef: (value) => {
    dispatch(setDesignFixedAnchorageDepthFixedAnchorageHef(value));
  },
  setEmbedmentDepthOption: (value) => {
    dispatch(setDesignEmbedmentDepthOption(value));
  }
});

export default connect(mapState, mapDispatch)(FixedAnchorageDepth);



// WEBPACK FOOTER //
// ./src/views/Design/components/GeneralCalculationDesign/FixedAnchorageDepth.js